module.exports = __webpack_public_path__ + "img/pricing_bottom_danger.0d93269b.png";